import { CohortIntensity } from "../../../../models/CohortIntensity";
import { CursusStageCadre } from "../../../../models/CursusStageCadre";
import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";
import {
  ComplianceForm,
  CreateCursusStagePayload,
  CreateCursusStageResponse,
  CursusStageForm,
} from "./CreateCursusStagePopup.d";

export const COMPLIANCE_TYPES = ["rncp", "rs", "azav"];

export const isComplianceValid = (form: ComplianceForm | null) => {
  if (!form) return true;
  return (
    COMPLIANCE_TYPES.includes(form.type) &&
    [form.name, form.code, form.certifier_name].every((value) => value.trim() !== "" && value.length <= 255) &&
    [form.internship_duration_days, form.internship_duration_hours, form.end_of_study_duration].every(
      (value) => value === null || (Number.isInteger(value) && value >= 0)
    ) &&
    form.skill_blocks.every((block) => block.name.trim() !== "" && block.name.length <= 255)
  );
};

export const emptyCursusStageForm = (): CursusStageForm => ({
  content: "",
  cursus_prefix: "",
  default_cadre: CursusStageCadre.DEFAULT,
  deployment_name: "",
  dt_end: "",
  dt_start: "",
  end_of_formation_document: "",
  evaluations: "",
  format: CohortIntensity.continuous,
  hours_spent_on_masterclass: null,
  hours_spent_on_modules: null,
  hours_spent_on_project: null,
  is_disabled: false,
  language: "en-US",
  mediator: "",
  objectives: "",
  pedagogy_leader_diplomas: "",
  pedagogy_leader_id: null,
  pedagogy_leader_references: "",
  prerequisites: "",
  presentation_document_url: "",
  priority: null,
  total_hours: null,
  training_organization: "",
});

export const emptyComplianceForm = (): ComplianceForm => ({
  type: "rncp",
  certifier_name: "",
  name: "",
  code: "",
  internship_needed: false,
  internship_duration_hours: null,
  internship_duration_days: null,
  internship_exemption_conditions: null,
  end_of_study_defense: false,
  end_of_study_duration: null,
  end_of_study_conditions: null,
  end_of_study_external_superview: null,
  useful_links: "[]",
  skill_blocks: [],
});

export const buildCreateCursusStagePayload = (
  form: CursusStageForm,
  compliance: ComplianceForm | null,
  flagIds: number[]
): CreateCursusStagePayload => ({
  ...form,
  external_compliance: compliance && {
    ...compliance,
    skill_blocks: compliance.skill_blocks.map((block, order) => ({ ...block, order })),
  },
  flag_ids: flagIds,
});

export const createCursusStage = (
  cursusId: string,
  payload: CreateCursusStagePayload,
  language: string,
  setIsSaving: Function,
  onSuccess: Function
) => {
  setIsSaving(true);
  ApiService.post(`cursus/${cursusId}/stages`, payload)
    .then((response: { data: CreateCursusStageResponse }) => onSuccess(response.data.cursus_stage.id))
    .catch(() => alert(translate(language, "PAGES.COURSE.MODALS.CREATE_STAGE.ERROR")))
    .finally(() => setIsSaving(false));
};
